export default __webpack_public_path__ + "static/media/Back.b7bcead4.svg";